import { Event } from "../Event";

export class DigitalAdmissionCandidateAcceptWhatsEvents extends Event {
    public onChange = (value: any, setField: any, setState: any, formValues: any) => {
        this.setState("loadings", ["digital_admission_candidate_cell_phone"])

        if(value) {
            this.setField("digital_admission_candidate_cell_phone", {
                required: true,
                readonly: false
            })
        } else {
            this.setField("digital_admission_candidate_cell_phone", {
                required: false,
                readonly: true
            })

            this.setFieldValue("digital_admission_candidate_cell_phone", "")
        }

        setTimeout(() => {
            this.setState("loadings", [])
        }, 250)
    }
}